import withRerenderPrevent from '../../common/with-rerender-prevent';
import { getChannelById } from '../../models/channels/selectors';
import useScreenTitle from '../../common/use-screen-title';
import useContentFeed from '../../common/use-content-feed';
import Page, { PageMain, PageSidebar } from '../../components/ui/page';
import ChannelDetails from '../../components/v2/channel/channel-details/channel-details';
import Feed from '../../components/feed';
import NotFound from '../not-found';
import { useParams } from 'react-router-dom';
import { usePatronSelector } from '../../common/use-patron-selector';

const ChannelFeed = () => {
  const { channelId } = useParams<{ channelId: string }>();
  const channel = usePatronSelector((state) =>
    getChannelById(state, channelId)
  );
  const { name: title } = channel ?? {};

  useScreenTitle(title);

  const analyticsData = {
    content_channel_id: channelId,
    content_channel_name: title ?? '',
    location: 'channel_feed',
  };

  const { fetching, feedItems, page, canLoadMore, fetchFeed } = useContentFeed({
    channelId,
  });

  return channel ? (
    <Page className="channel-feed">
      <PageSidebar>
        <ChannelDetails channelId={channelId} analyticsData={analyticsData} />
      </PageSidebar>

      <PageMain>
        <Feed
          items={feedItems}
          page={page}
          fetching={fetching}
          canLoadMore={canLoadMore}
          fetchFeed={fetchFeed}
          analyticsData={analyticsData}
          titleHeadingLevel={2}
        />
      </PageMain>
    </Page>
  ) : (
    <NotFound />
  );
};

export default withRerenderPrevent(ChannelFeed);
